var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVolumePlus = function SvgIconVolumePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.792 10.057v4.585H3.2c-.11 0-.2-.087-.2-.194V10.25c0-.106.09-.193.2-.193zm1-.13v4.844l.03.017 7.172 4.323c.133.08.306-.012.306-.164V5.752c0-.152-.173-.244-.306-.164L6.821 9.911zm-1 5.68h.5l7.172 4.322c.8.482 1.836-.073 1.836-.982V5.752c0-.91-1.036-1.464-1.836-.983L6.292 9.092H3.2c-.663 0-1.2.519-1.2 1.158v4.198c0 .64.537 1.159 1.2 1.159zm13.456-5.928a.5.5 0 0 1 .5.5v1.672h1.75a.5.5 0 1 1 0 1h-1.75v1.671a.5.5 0 1 1-1 0v-1.671h-1.75a.5.5 0 0 1 0-1h1.75v-1.672a.5.5 0 0 1 .5-.5",
    clipRule: "evenodd"
  })));
};
export default SvgIconVolumePlus;